import { ethereum } from '@0xtorch/core'
import { manta as viemManta } from 'viem/chains'
import { type Client, createClient } from '../../client'
import type { Explorer } from '../../explorer'
import { createBlockscout } from '../../explorer'
import type { Chain } from '../types/chain'
import type { HttpRpc } from '../types/rpc'

export const createMantaPacificChain = ({
  explorerProxyUrl: proxyUrl,
}: {
  explorerProxyUrl?: string
}) =>
  createMantaPacificChainCustom({
    client: createClient({
      chain: viemManta,
      httpRpcs: mantaPacificHttpRpcs,
    }),
    explorer: createBlockscout({
      name: 'Manta Pacific explorer',
      baseUrl: 'https://pacific-explorer.manta.network',
      apiBaseUrl: 'https://pacific-explorer.manta.network/api',
      proxyUrl,
    }),
  })

type CreateMantaPacificChainParameters = {
  client: Client
  explorer: Explorer
}

export const createMantaPacificChainCustom = ({
  client,
  explorer,
}: CreateMantaPacificChainParameters): Chain => ({
  id: 169,
  network: 'manta-pacific',
  name: 'Manta Pacific',
  nativeToken: {
    name: 'Ethereum',
    symbol: 'ETH',
    decimals: 18,
    currency: ethereum,
  },
  wrappedTokenAddresses: new Set([
    '0x0dc808adce2099a9f62aa87d9670745aba741746',
  ]),
  explorer,
  client,
  blockTime: 10_000,
  coingeckoId: 'manta-pacific',
  defillamaId: 'manta',
})

export const mantaPacificHttpRpcs: HttpRpc[] = [
  {
    url: 'https://pacific-rpc.manta.network/http',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://1rpc.io/manta',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 1000n,
  },
  {
    url: 'https://manta-pacific-gascap.calderachain.xyz/http',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 20_000n,
  },
  // Endpoint is not working
  // {
  //   url: 'https://www.tencentcloud-rpc.com/v2/manta/manta-rpc',
  //   getLogsIsUsable: false,
  //   getLogsMaxBlockRange: 0n,
  // },
  {
    url: 'https://r1.pacific.manta.systems/http',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 1000n,
  },
  {
    url: 'https://manta-pacific.calderachain.xyz/http',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 20_000n,
  },
  {
    url: 'https://manta-pacific.drpc.org',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
]

export const mantaPacificWebsocketRpcUrls: readonly string[] = []
